import { takeEvery, takeLatest } from 'redux-saga/effects';
import * as types from '../actions/actionTypes';

import { dataFromLitiumSaga } from './dataFromLitiumSaga';
import { globalSearch, quickSearch } from './globalSearch';
import { cmsPage } from './articlePage';
import { brands } from './brands';
import { products, product, productsList } from './products';
import { category } from './category';
import { cart, addCartItem, removeCartItem, deleteCartRow } from './cart';
import { instagram } from './instagram';
import { deliveryMethods } from './deliveryMethods';
import { designers } from './designers';

export function* watchObjectData() {
  yield takeEvery(types.FETCH_PRODUCTS_PAGE_VIEW, dataFromLitiumSaga);
  yield takeEvery(types.FETCH_PRODUCTS_CATEGORY_PAGE_VIEW, dataFromLitiumSaga);
  yield takeEvery(types.FETCH_TEST_CART, dataFromLitiumSaga);
  yield takeEvery(types.FETCH_ARTICLE_PAGE_VIEW, cmsPage);
  yield takeLatest(types.FETCH_GLOBAL_SEARCH, globalSearch);
  yield takeLatest(types.FETCH_QUICK_SEARCH, quickSearch);
  yield takeEvery(types.FETCH_BRAND_DATA, brands);
  yield takeEvery(types.FETCH_DESIGNERS_DATA, designers);
  yield takeEvery(types.FETCH_PRODUCTS, products);
  yield takeEvery(types.FETCH_CAMPAIGN_PRODUCTS, productsList);
  yield takeEvery(types.FETCH_CATEGORY_META_DATA, category);
  yield takeLatest(types.ADD_PRODUCT_TO_CART, addCartItem);
  yield takeLatest(types.FETCH_CART, cart);
  yield takeLatest(types.REMOVE_PRODUCT_FROM_CART, removeCartItem);
  yield takeLatest(types.DELETE_CART_ROW, deleteCartRow);
  yield takeEvery(types.FETCH_INSTAGRAM_POSTS, instagram);
  yield takeLatest(types.FETCH_DELIVERY_METHODS, deliveryMethods);
  yield takeEvery(types.FETCH_PRODUCT, product);
}



// WEBPACK FOOTER //
// ./src/sagas/watcher.js